import React from 'react';
import { Link } from 'react-router-dom';
import { FaGlobeAmericas, FaAd, FaMicrophone, FaVideo, FaEnvelope, FaChartLine } from 'react-icons/fa';
import LanguageBadges from '../components/LanguageBadges';
import '../styles/HomePage.css';

const HomePage = () => {
  // Email protection function
  const revealEmail = (e) => {
    e.preventDefault();
    const name = 'coleman';
    const domain = 'dubbah';
    const tld = 'co';
    window.location.href = `mailto:${name}@${domain}.${tld}`;
  };

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Double Your Market Reach with Professional Dubbing</h1>
            <p className="subtitle">Unlock new revenue streams in 28+ languages while maintaining your brand's authentic voice</p>
            <div className="hero-buttons">
              <a href="#" onClick={revealEmail} className="primary-button">
                <FaEnvelope className="icon-margin-right" /> Transform Your Content
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Language Section */}
      <section className="languages">
        <div className="container">
          <h2>Tap into massive global markets instantly</h2>
          <p>Convert one audience into dozens with professional dubbing in these high-value languages</p>
          <LanguageBadges />
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <div className="container">
          <h2>Three Steps to Global Impact</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-icon"><FaVideo /></div>
              <h3>Share Your Vision</h3>
              <p>We analyze your content and target markets to maximize ROI</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-icon"><FaMicrophone /></div>
              <h3>Perfect Voice Match</h3>
              <p>Get voices that resonate with local audiences and drive engagement</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-icon"><FaChartLine /></div>
              <h3>See Results Fast</h3>
              <p>Launch campaigns quickly and watch your global metrics soar</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="benefits">
        <div className="container">
          <h2>Turn One Ad Into Global Success</h2>
          <div className="benefits-grid">
            <div className="benefit">
              <div className="benefit-icon"><FaAd /></div>
              <h3>Ad Localization That Converts</h3>
              <p>Increase conversion rates by 35% with culturally-tuned dubbing that speaks directly to each market's unique buying triggers</p>
            </div>
            <div className="benefit">
              <div className="benefit-icon"><FaMicrophone /></div>
              <h3>Dynamic Content Optimization</h3>
              <p>Refresh and repurpose existing ads with new hooks and messaging without expensive reshoots or production delays</p>
            </div>
            <div className="benefit">
              <div className="benefit-icon"><FaGlobeAmericas /></div>
              <h3>Save 60% On Production Costs</h3>
              <p>Eliminate expensive re-shoots while maintaining premium quality by dubbing your existing content for multiple regions</p>
            </div>
          </div>
          <div className="cta-container">
            <a href="#" onClick={revealEmail} className="primary-button">
              <FaEnvelope className="icon-margin-right" /> Maximize Your ROI Today
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
